import { getGoogleDate } from '@iotv/datamodel-core';
import { AppValueTypes, isScoreKeyLike, ScoreKeyToReadingKey, SortOrder } from '@iotv/iotv-v3-types';
import { camelCase_to_Sentence, toTitleCase } from '../../../helpers/format';
const debug = process.env.REACT_APP_DEBUG && false;
export const assembleItems = ({ contextObject, historyStore }) => {
    // Assemble items
    const stateSnapshots = historyStore ? historyStore.getStateSnapshotArray(SortOrder.DESCENDING) : [];
    const type = `${contextObject.type ?? 'Unkown'}_Metric`;
    const metricItems = stateSnapshots.map((stateSnapshot, i) => {
        const { state: { ...atts }, timestamp, } = stateSnapshot;
        const id = `${contextObject?.id ?? 'unknownId'}_${i}_${timestamp}`;
        const pk = contextObject?.sk ?? 'unknownParentSk';
        const sk = `${type}:${id}`;
        return {
            type,
            sk,
            pk,
            id,
            ...atts,
            timestamp,
            time: timestamp ? getGoogleDate(timestamp) : undefined,
        };
    });
    debug && console.log('HistoryObjectDataGrid metrics', metricItems);
    return metricItems;
};
export const filterKeysToViewDefinition = (filterMetricKeys) => {
    debug && console.log('Filtering keys', filterMetricKeys);
    const viewDefinition = {};
    filterMetricKeys?.forEach((key) => {
        const viewDefinitionKey = {
            key,
            editable: false,
            label: key.toUpperCase(),
            precision: undefined,
            stateFn: undefined,
            type: AppValueTypes.NUMBER,
            unit: undefined,
            validationRx: undefined,
            enumKV: undefined,
            failsValidationText: undefined,
        };
        viewDefinition[key] = viewDefinitionKey;
    });
    // Sort by predefined order here ...
    return viewDefinition;
};
export const filterKeysByTypeToViewDefinition = (filterMetricKeys, arrayMap) => {
    const keys = arrayMap ? filterMetricKeys?.filter((key) => arrayMap[key] && arrayMap[key].every((item) => item === null || typeof item !== 'object')) : [];
    keys?.unshift('time');
    keys?.unshift('timestamp');
    return filterKeysToViewDefinition(keys);
};
const defaultColumnMaps = {
    batteryPercentage: {
        type: 'number',
        width: 80,
    },
    deviceBatteryVoltage: {
        type: 'number',
        width: 80,
    },
    deviceEui: {
        type: 'string',
        hideable: false,
        width: 140,
    },
    gatewayEui: {
        type: 'string',
        width: 140,
    },
    rssi: {
        type: 'number',
        width: 50,
    },
    sf: {
        type: 'number',
        width: 50,
    },
    snr: {
        type: 'number',
        width: 60,
    },
    fCnt: {
        type: 'number',
        width: 80,
    },
    updated_at: {
        type: 'number',
        width: 150,
    },
};
export const generateCol = (metricItem, injectDeviceMetrics = false) => {
    const keys = Object.keys(metricItem ?? { err: 'nothing to see' });
    const columnMap = {
        time: {
            headerName: 'Time',
            hideable: false,
            width: 180,
        },
    };
    keys.forEach((key) => {
        if (!['type', 'pk', 'sk', 'id', 'status', 'timestamp', 'time', 'payload'].includes(key)) {
            let headerName = toTitleCase(camelCase_to_Sentence(key, false));
            if (isScoreKeyLike(key))
                headerName = `[Score] ${toTitleCase(camelCase_to_Sentence(ScoreKeyToReadingKey(key)))}`;
            columnMap[key] = defaultColumnMaps[key] ?? { headerName };
        }
    });
    return {
        ...columnMap,
        ...(injectDeviceMetrics
            ? {
                batteryVoltage: {
                    headerName: 'Battery Voltage',
                    width: 180,
                },
                rssi: {
                    headerName: 'RSSI',
                    width: 100,
                },
                snr: {
                    headerName: 'SNR',
                },
                messageType: {
                    headerName: 'Message Type',
                    width: 120,
                },
                fCnt: {
                    headerName: 'Frame',
                },
                payload: {
                    headerName: 'Payload',
                    width: 450,
                },
                firmwareVersion: {
                    headerName: 'Firmware Version',
                },
            }
            : {}),
    };
};
export const defaultReadingKeyToPresentableNameMap = {
    batteryPercentage: 'Battery (%)',
    deviceBatteryVoltage: 'Battery (V)',
    deviceEui: 'EUI',
    gatewayEui: 'Gateway',
    rssi: 'RSSI',
    sf: 'SF',
    snr: 'SNR',
    fCnt: 'Frame',
    updated_at: 'Updated',
};
